import React, { FunctionComponent, useEffect, useState } from "react";
import { Fields, UnlimitedWidgets } from "@webtie-ch/form-widget-library";
import { Spinner } from "react-bootstrap";
import validator from "@rjsf/validator-ajv8";
import Form from "@rjsf/react-bootstrap";

import FormSchema from "../../models/schema/FormSchema";
import { PrimaryButton } from "../common/button/Buttons";

interface Props {
  formSchema: FormSchema;
  formData: any;
  onSubmit: (formData: any) => Promise<void>;
}
const RegistrationEditor: FunctionComponent<Props> = ({ formData: initialFormData, formSchema, onSubmit }: Props) => {
  const [isLoading, setLoading] = useState<boolean>(false);
  const [formData, setFormData] = useState<any>(initialFormData);

  useEffect(() => {
    setFormData(initialFormData);
  }, [initialFormData]);

  function submit(data: any): void {
    setLoading(true);
    onSubmit(data).finally(() => setLoading(false));
  }

  return (
    <Form
      validator={validator}
      formData={formData}
      onChange={(e: any) => setFormData(e.formData ?? {})}
      schema={formSchema.formSchema}
      uiSchema={formSchema.uiSchema}
      onSubmit={(e: any) => submit(e.formData)}
      widgets={UnlimitedWidgets}
      fields={Fields}>
      <PrimaryButton disabled={isLoading} type={"submit"}>
        Speichern {isLoading && <Spinner size={"sm"} animation={"border"} />}
      </PrimaryButton>
    </Form>
  );
};

export default RegistrationEditor;
